import React, { createContext, useContext, useState } from 'react';
import { getColors } from '../theme/colors';
import { localStorageKeys } from '../constants/storage-keys';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Check local storage for dark mode preference
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem('isDarkMode');
    return savedTheme ? JSON.parse(savedTheme) : true;
  };

  const [isDarkMode, setIsDarkMode] = useState(getInitialTheme);

  // Toggle theme and save to local storage
  const toggleTheme = () => {
    setIsDarkMode((prevMode) => {
      const newMode = !prevMode;
      localStorage.setItem(localStorageKeys.darkThemePreference, JSON.stringify(newMode));
      return newMode;
    });
  };

  // Update colors based on current theme mode
  const colors = getColors(isDarkMode);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme, colors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
